<div class="row-content">
  <div class="row-name">
    {{ params.data.id + 1 }}.
    @if (params.data.isTeamLeader) {
      {{ params.data.fullName }} (You).
    } @else {
      {{ params.data.fullName }}
    }
  </div>
  <div class="row-email">
    {{ params.data.emailAddress }}
  </div>
  <div class="row-access-code">
    {{ params.data.accessCode }}
  </div>
</div>
<app-edit-member-dialog [passedParams]="params"></app-edit-member-dialog>
